import React from "react";

interface InlineErrorProps {
    message: string;
}

export const InlineError = ({ message }: InlineErrorProps) => (
    <div className="row mb-3">
        <div className="col">
            <div data-testid="inline-error" style={{
                color: '#d13212',
                backgroundColor: '#fdf3f1',
                border: '1px solid #d13212',
                borderRadius: '4px',
                padding: '0.75rem 1rem',
                fontSize: '0.875rem'
            }}>
                {message}
            </div>
        </div>
    </div>
);
